import React from "react";
import StudentsTable from "../../../components/StudentsTable/StudentTable";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useDispatch } from "react-redux";
import { instructorStudentsAPI } from "../../../redux/features/intructorSlice";
import InstructorNotification from "../../../components/Notification/InstructorNotification";

const Students = () => {
  const dispatch = useDispatch();

  const fetchInstructorStudents = async (token) => {
    return await dispatch(instructorStudentsAPI({ token })).unwrap();
  };

  return (
    <>
      {/* Top Bar */}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ad-heading-04 fw-bold mb-8">Students</h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <InstructorNotification />
          </div>
        </div>
      </div>
      <div className="card-default-style px-14 py-40">
        <StudentsTable fetchApi={fetchInstructorStudents} linkTo="/student-details" />
      </div>
      
    </>
  );
};

export default Students;
